<template>
  <div id="app">
    <router-view v-if="!$route.meta.keepAlive"/>
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"> </router-view>
    </keep-alive>

  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@import "../static/css/common.css";
body{
    position: relative;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: auto;
}
.crumb {
  height: 36px;
  line-height: 36px !important;
}
/* 
弹框的层级大于百度编辑器内置弹框
解决：设置百度编辑器成绩大于2000就可以。
*/

#edui_fixedlayer {
  z-index: 8000 !important;
}
.edui-dialog {
  z-index: 9999 !important;
}
.el-menu{
  width: 64px;
}
</style>

 


// WEBPACK FOOTER //
// src/App.vue